module.exports = __webpack_public_path__ + "img/bv-app-store-new-stop-en.fc2eb30c.png";